import { service as client } from '@/apis/client'

export const logError = async (data: object) => {
  return client.post('/log/error', data)
}
